import "./ToolBar.css"
import {observer} from "mobx-react-lite";
import {Button} from "primereact/button";
import {ToolBarButtonType, toolBarStore} from "../stores/ToolBarStore";

function ToolBar() {
    function handleClick(e: any, buttonType: ToolBarButtonType) {
        toolBarStore.setButton(buttonType);
        if (buttonType == ToolBarButtonType.DOSC) {
            window.location.href = "/docs/hg798"
        }
        if (buttonType == ToolBarButtonType.APP) {
            window.location.href = "/"
        }
        e.currentTarget.blur();
        e.preventDefault();
    }

    return (<>
        <div className={"tool-bar"}>
            <Button
                link={toolBarStore.getSelectedButton() != ToolBarButtonType.APP}
                onClick={(e) => handleClick(e, ToolBarButtonType.APP)}
            >
                App
            </Button>
            <Button
                link={toolBarStore.getSelectedButton() != ToolBarButtonType.DOSC}
                onClick={(e) => handleClick(e, ToolBarButtonType.DOSC)}
            >
                Docs
            </Button>
        </div>
    </>)
}

export default observer(ToolBar)